import { MessagesScreen } from '~/components/domain/messages/MessagesScreen';

export default function MessagesDeleted() {
  return <MessagesScreen initialMessageType="deleted" />;
}
